var map = {
	"./static1.gif": 473,
	"./static2.gif": 638,
	"./static3.gif": 487,
	"./static4.gif": 324,
	"./static5.gif": 589,
	"./static6.gif": 490,
	"./static7.gif": 211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 889;